export default __webpack_public_path__ + "static/media/fish-bg-smm.72305bc6.svg";